export const AUDIO_CHUNK_SIZE_SECONDS = 5 * 60;

export interface DialogSupportState {
  isDialogSupportStartModalOpen: boolean;
  dialogSupportHasBeenRecording: boolean;
  summaryGenerationStatus: SummaryGenerationStatus;
  summaryResult: SummaryResult | null;
}

export type MeetingForm = 'Personal' | 'Digital';

export interface DialogSupportSettings {
  meetingForm: MeetingForm;
  selectedDeviceId?: string;
}

export interface SummaryResult {
  summary: string;
  status: SummaryStatus;
  partialDetails?: MissingPartialsInfo;
}

export interface GenerateSummaryResult {
  summary?: string;
  status: SummaryStatus;
  partialDetails?: MissingPartialsInfo;
}

export interface MissingPartialsInfo {
  missingPartialsCount: number;
  totalPartialsCount: number;
}

export enum SummaryStatus {
  FullSummary = 'FullSummary',
  PartialSummary = 'PartialSummary',
  NoSummary = 'NoSummary',
}

export enum SummaryGenerationStatus {
  Inactive = 'inactive',
  WaitingForTranscription = 'waiting',
  GeneratingSummary = 'generating',
  Completed = 'completed',
  Failed = 'failed',
}

export const emptyDialogSupportState: DialogSupportState = {
  isDialogSupportStartModalOpen: false,
  dialogSupportHasBeenRecording: false,
  summaryGenerationStatus: SummaryGenerationStatus.Inactive,
  summaryResult: null,
};

export const emptyDialogSupportSettings: DialogSupportSettings = {
  meetingForm: 'Personal',
  selectedDeviceId: undefined,
};
